import React, { ReactNode } from 'react';
interface StatCardProps {
  label: string;
  value: string | number;
  icon?: ReactNode;
  hint?: string;
  accent?: string;
}
export function StatCard({
  label,
  value,
  icon,
  hint,
  accent
}: StatCardProps) {
  return <div className="rounded-2xl border border-border bg-background p-6 shadow-soft transition-colors hover:border-primary/25" data-id="element-221" data-mp="2w963armblhno">
      <div className="flex items-start justify-between gap-3" data-id="element-222" data-mp="307x00xmvixa9">
        <p className="text-sm text-muted-foreground" data-id="element-223" data-mp="23ljwzblpjyx4">{label}</p>
        {icon && <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary" style={accent ? {
        backgroundColor: `${accent}1A`,
        color: accent
      } : undefined} data-id="element-224" data-mp="28iaf04h2p4l6">
            {icon}
          </span>}
      </div>
      <p className="mt-4 text-3xl font-semibold tracking-tight text-navy" data-id="element-225" data-mp="2hd89hfzvcpem">{value}</p>
      {hint && <p className="mt-1.5 text-xs text-muted-foreground" data-id="element-226" data-mp="1kreorbs9mhg1">{hint}</p>}
    </div>;
}